import { IEquatable } from './entity';
import { IMedia } from './media';

export type IRoute = {
  // required
  category: IEquatable;
  id: string;
  locale: string;
  market: string;
  page: IEquatable;
  resolvedCategory: IEquatable;
  schema: string;
  title: string;
  // optional
  _status?: 'published' | 'draft';
  isDefault?: boolean;
  isProtected?: boolean;
  isRoot?: boolean;
  media?: {
    url: string;
    src?: string;
    type: string;
    updatedAt?: Date | string;
  };
  noindex?: boolean;
  order?: number;
  publicRedirect?: string;
  template?: string;
  updatedAt?: Date | string;
  useSplat?: boolean;
};

export type IRouteCanonical = IRoute & {
  alternates: IRoute[];
};

export type IRouteLink = {
  category: IEquatable;
  href: string;
  id: IEquatable;
  items?: IRouteLink[];
  media?: IMedia;
  schema: string;
  title: string;
};

export type IRouteParams = Record<string, any> & {
  id: IEquatable,
  locale: string,
  market: string,
};
